import {
  E_CARD_SIZE_ID,
  LARGE_FLOWER_SIZE_ID,
  STANDARD_FLOWER_SIZE_ID,
  Variant,
  GIANT_FLOWER_SIZE_ID,
} from '@moonpig/web-shared-products'
import { useVariantSelectorModuleLocaleText } from '../VariantSelectorModule.locale'

export const getVariantDescription = (
  variant: Pick<Variant, 'key' | 'subtitle' | 'dimensions'>,
  localiseText: ReturnType<typeof useVariantSelectorModuleLocaleText>,
) => {
  switch (variant.key) {
    case E_CARD_SIZE_ID:
      return localiseText('common.sent_instantly_via_email')
    case STANDARD_FLOWER_SIZE_ID:
      return localiseText('common.flower_variant_description_standard')
    case LARGE_FLOWER_SIZE_ID:
      return localiseText('common.flower_variant_description_large')
    case GIANT_FLOWER_SIZE_ID:
      return localiseText('common.flower_variant_description_giant')
    default:
      return variant.subtitle || variant.dimensions?.description
  }
}
